import { ErrorMessage, Form, Formik } from 'formik';
import { Button, Header, Grid, Message, Icon, Label } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
import { UserFormValues } from '../../app/models/user';
import { returnPhoneOrEmpty } from '../../app/common/util/util';
import { stateOptions } from '../../app/common/options/stateOptions';
import { observer } from 'mobx-react-lite';
import MyTextInput from '../../app/common/form/MyTextInput';
import MySelectInput from '../../app/common/form/MySelectInput';
import MyZipCodeInput from '../../app/common/form/MyZipCodeInput';
import ValidationErrors from '../errors/ValidationErrors';
import * as Yup from 'yup';
import { registerCommonValidationSchema, registerValidationSchema } from '../../app/common/form/FormikFormValidations';
import MyPhoneInput from '../../app/common/form/MyPhoneInput';

interface Props {
    isRedirect: boolean
}

export default observer(function PermitHolderForm({ 
    isRedirect
 }: Props) {
    const {userStore} = useStore();
    const { register, user } = userStore;

    return (
        <Formik
            initialValues={new UserFormValues(user!)}
            onSubmit={(values, {setErrors}) => register(values, isRedirect).catch(error => 
                setErrors({error}))}
            validationSchema={() => Yup.lazy((values) => {
                // new user
                if (+values.subscriberID === 0) {
                    return registerValidationSchema;
                } else { // logged-in user
                    // update user data include password
                    // if (+values.subscriberID > 0 && changePassword) {
                    //     return registerValidationSchema;
                    // } else {
                        // update user data except password
                        return registerCommonValidationSchema;
                    // }
                }
            })}
        >
        {({handleSubmit, isSubmitting, errors, dirty, values, isValid}) => (
            <Form className='ui form error' onSubmit={handleSubmit} autoComplete='off'>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Message icon>
                                    <Icon name='search' />
                                    <Message.Content>
                                        <Message.Header>Update Permit Holder Information</Message.Header>
                                        Please review/update your Permit Holder Information. To change your email and password, please click the button below.
                                        <div>
                                            <Label basic
                                                as='a'
                                                size='large'
                                                color='blue' 
                                                href={`/permits`}
                                            >{`Update my WSF Account`}</Label>
                                        </div>
                                    </Message.Content>
                                </Message>
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Header
                                    content='Username and Password'
                                    color='teal'
                                    sub
                                />
                            </Grid.Column>
                            <Grid.Column computer={8} tablet={8} mobile={16}>
                                <label>Email</label>
                                <MyTextInput name='subscriberEmail' placeholder='Email' tabIndex={1} />
                            </Grid.Column>
                            <Grid.Column computer={8} tablet={8} mobile={16}>
                                {!isValid && returnPhoneOrEmpty(values.subscriberPhone) === '' && (
                                        <Message icon color='red'>
                                            <Icon name='exclamation' />
                                            <Message.Content>
                                                <Message.Header>Invalid Phone</Message.Header>
                                                Please re-enter phone number as the following format (123) 123-1234.
                                            </Message.Content>
                                        </Message>
                                )}
                                <label>Phone</label>
                                <MyPhoneInput name='subscriberPhone' placeholder='Phone' tabIndex={2} />
                            </Grid.Column>
                        </Grid.Row>

                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Header
                                    content='Contact Information'
                                    color='teal'
                                    sub
                                />
                            </Grid.Column>
                            <Grid.Column computer={8} tablet={8} mobile={16}>
                                <label>First Name</label>
                                <MyTextInput name='subscriberNameFirst' placeholder='First Name' tabIndex={5} />

                                <label>Address</label>
                                <MyTextInput name='address' placeholder='Address' tabIndex={7} />
                            </Grid.Column>
                            <Grid.Column computer={8} tablet={8} mobile={16}>
                                <label>Last Name</label>
                                <MyTextInput name='subscriberNameLast' placeholder='Last Name' tabIndex={6} />

                                <label>Address 2</label>
                                <MyTextInput name='address2' placeholder='Address 2' tabIndex={8} />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column computer={5} tablet={5} mobile={16}>
                                <label>City</label>
                                <MyTextInput name='city' placeholder='City' tabIndex={9} />
                            </Grid.Column>
                            <Grid.Column computer={5} tablet={5} mobile={16}>
                                <label>State</label>
                                <MySelectInput 
                                    options={stateOptions} 
                                    placeholder='--- Select State ---'  
                                    name='state' 
                                    tabIndex={10} 
                                />
                            </Grid.Column>
                            <Grid.Column computer={5} tablet={5} mobile={16}>
                                <label>Zip Code</label>
                                <MyZipCodeInput name='zipCode' placeholder='Zip Code' tabIndex={11} />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column width={16}>
                            <ErrorMessage 
                                name='error' render={() => 
                                <ValidationErrors errors={errors.error}/>}
                            />
                            <Button 
                                disabled={!dirty || !isValid}
                                loading={isSubmitting}
                                color='teal' 
                                content='Update'
                                fluid 
                            />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
            </Form>
            )}
        </Formik>
    )
})